import type { ComponentType } from 'react'

import { MicrosoftLogo } from '@/components/icons/MicrosoftLogo'

export type SsoProviderId = 'azure'

export interface SsoProviderConfig {
  id: SsoProviderId
  labelKey: string
  Logo: ComponentType<{ className?: string }>
  backendInitPath: string
  backendInvitePath: (token: string) => string
}

export const SSO_PROVIDERS: SsoProviderConfig[] = [
  {
    id: 'azure',
    labelKey: 'auth.continue_with_microsoft',
    Logo: MicrosoftLogo,
    backendInitPath: '/api/v1/auth/azure',
    backendInvitePath: (token) => `/api/v1/auth/azure/invite/${token}`,
  },
]

export const findSsoProvider = (
  id: SsoProviderId,
): SsoProviderConfig | undefined =>
  SSO_PROVIDERS.find((provider) => provider.id === id)
